const ToggleObj = {
    el: null,
    button: null,
    container: null,
    focusableItems: null,
    isOpen: false,
    controls: ''
}

export function Toggle() {
    const Els = document.querySelectorAll('.js-toggle')
    return Array.from(Els).map(createToggle)
}

function createToggle(el) {
    const Obj = Object.assign({}, ToggleObj)
    init.call(Obj, el)
    return Obj
}

function init(el) {
    if (!el) {
        return
    }

    this.el = el
    this.button = this.el.querySelector('.js-toggle-btn')
    this.controls = this.button.getAttribute('aria-controls')
    this.container = document.querySelector('#' + this.controls)
    this.focusableItems = this.container.querySelectorAll(
        'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]'
    )

    document.addEventListener('click', (evt) => {
        if (evt.target.classList.contains('js-toggle-btn') && evt.target.tagName === 'BUTTON') {
            toggleDropdown.call(this, evt, true)
        }
    })
    document.addEventListener('mouseover', toggleDropdown.bind(this))
    this.el.addEventListener('keydown', handleFocus.bind(this))
    this.container.addEventListener('keydown', handleFocus.bind(this))
    document.addEventListener('keydown', (evt) => {
        if (evt.key === 'Escape' && this.isOpen) {
            close.call(this)
        }
    })
}

function toggleDropdown(evt, isClick) {
    if (evt.target.closest('.js-toggle') !== this.el) {
        if (evt.target.closest('#' + this.controls) === this.container) {
            return
        }

        close.call(this)
    }

    if (evt.target !== this.button) {
        return
    }

    if (!this.button.dataset.active) {
        open.call(this, isClick)
    } else if (isClick) {
        close.call(this)
    }
}

function open(focus) {
    this.button.dataset.active = true
    this.button.setAttribute('aria-expanded', true)
    this.container.hidden = false
    this.container.dataset.active = true

    if (focus) {
        const firstATag = this.container.querySelector('a')
        firstATag && firstATag.focus()
    }
    this.isOpen = true
}

function close() {
    this.button.removeAttribute('data-active')
    this.button.setAttribute('aria-expanded', false)
    this.container.hidden = true
    this.container.removeAttribute('data-active')
    this.isOpen = false
}

function handleFocus(evt) {
    if (evt.key === 'ArrowDown' && evt.ctrlKey && evt.shiftKey && !this.isOpen) {
        open.call(this, true)
        return
    }

    if (evt.key === 'ArrowUp' && evt.ctrlKey && evt.shiftKey && this.isOpen) {
        close.call(this)
        this.button.focus()
        return
    }

    if (evt.key !== 'Tab' || !this.isOpen) {
        return
    }

    if (this.focusableItems.length === 1) {
        evt.preventDefault()
        return
    }

    const currentActive = document.activeElement
    const lastFocusable = this.focusableItems[this.focusableItems.length - 1]

    if (evt.shiftKey) {
        if (currentActive === this.button) {
            evt.preventDefault()
            lastFocusable.focus()
        }
    } else {
        if (currentActive === lastFocusable) {
            evt.preventDefault()
            this.button.focus()
        }
    }
}
